import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { EMarket } from 'legacy/lut/configs/geo'
import { lookupGetStateOld } from 'legacy/lut/store'
import { useEffect, useMemo, useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { CrudStore } from 'core/types/crudStore'
import { usePartnerTerritory } from 'onboarding/components/widgets/public/forms/hooks/usePartnerTerritory'
import { useParentRequest } from 'onboarding/hooks/useParentRequest'
import { useRequest } from 'onboarding/hooks/useRequest'

import { getSerializedNamesByCodes } from '../../../../../../../helpers/getSerializedNamesByCodes'
import { EFormSource } from '../../../FormSelector'

export interface IPartnerShipLA {
  EntryId: number
  Email: string
  FirstName: string
  JobFunction: string
  LastName: string
  MobilePhone_Prefix: string
  MobilePhone: string
  WorkPhone_Prefix: string
  WorkPhone: string
  PartnerTerritory: string
  PartnerTerritoryISO: string
  RequestId: number
  JobTitle: string
  ForwarderAddress: string
  ForwarderContact: string
  ForwarderContactEmail: string
  ForwarderName: string
  ForwarderPhoneNumber: string
  ShipperName: string
  Destination: string
  IsInactiveUser: string
  InvitationCode: string
  InvitationCodeComment: string
}

export const usePartnerShipLA = (setItem: (value: IPartnerShipLA) => void, rid: string) => {
  const source = CrudStore.get(CrudStoreItemOnboarding.PartnerShipLA)
  const { req } = useRequest(rid)
  const { parentRequest } = useParentRequest(req.Parent)
  const request = useMemo(() => parentRequest ?? req, [req, parentRequest])
  const partnerTerritory = usePartnerTerritory()

  const [wip, setWip] = useState(true)

  const naCountriesList = useMemo(() => {
    return lookupGetStateOld()
      .references.countries.filter(
        (item: IObjectAny) => item.market === EMarket.northAmerica && item.hporg
      )
      .map((item: IObjectAny) => item.value)
  }, [])

  const reqFillSource = useMemo(() => {
    return CrudStore.get(CrudStoreItemOnboarding.RequestorLAFillData, 'req fill data')
  }, [])

  useEffect(() => {
    request.EntryId &&
      source.getById({ id: request.EntryId, keyField: 'RequestId' }).then((el: IPartnerShipLA) => {
        el && setItem(el)
        setWip(false)
      })
  }, [request.EntryId])

  const onSave = async (item: IObjectAny) => {
    setWip(true)
    item.PartnerTerritory = getSerializedNamesByCodes(
      item.PartnerTerritoryISO,
      partnerTerritory.countries
    )

    const formData: IForm | null = await source.getById({
      id: request.EntryId,
      force: true,
      keyField: 'RequestId',
    })
    if (formData) {
      item = { ...formData, ...item }
    }
    const newItem = {
      ...item,
      RequestId: request.EntryId,
    }

    if (item.EntryId) {
      const requestor = await reqFillSource.getById({
        id: request.EntryId,
        force: true,
        keyField: 'RequestId',
      })
      if (requestor) {
        const reqTer = requestor.PartnerTerritory.split(',').filter((item: string) =>
          naCountriesList.includes(item)
        )
        let resultTer = ''
        if (reqTer.length) {
          resultTer += reqTer.join(',')
        }
        if (item.PartnerTerritory) {
          resultTer += resultTer ? `,${item.PartnerTerritory}` : item.PartnerTerritory
        }
        await reqFillSource.update(EFormSource.RequestorToFillLAT1, [
          {
            ...requestor,
            PartnerTerritory: resultTer,
          },
        ])
      } else {
        await reqFillSource.create(EFormSource.RequestorToFillLAT1, [
          {
            PartnerTerritory: item.PartnerTerritory ? item.PartnerTerritory : '',
            RequestId: request.EntryId,
          },
        ])
      }
    }
    await source[formData ? 'update' : 'create'](EFormSource.PartnershipDetailsLA, [newItem])
    setWip(false)
  }

  return { wip, onSave, partnerTerritory }
}
